var appGemMaster = {

    /* --------------------------------------------
    smooth Scrolling to #anchor
    -------------------------------------------- */
    smoothScroller: function ()
    {
        $(".triggerScroll").on('click', function (event) {

            var root = $(this).attr('href');

            if (this.hash !== "" && window.location.href + this.hash != root)
            {
                event.preventDefault();
                var hash = this.hash;

                if ($(hash).length)
                {
                    $('html, body').stop().animate({
                        scrollTop: $(hash).offset().top - 100
                    }, 800, function ()
                    {
                        window.location.hash = hash;
                    });
                }
                else
                {
                    window.location.href = root;
                }
            }
        });
    }
};

$(document).ready(function () {
    appGemMaster.smoothScroller();
});